module.exports = __webpack_public_path__ + "img/clock-two-thirty.82fb890e.svg";